import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=207da414&scoped=true"
import script from "./user-agreement.vue?vue&type=script&lang=js"
export * from "./user-agreement.vue?vue&type=script&lang=js"
import style0 from "./user-agreement.vue?vue&type=style&index=0&id=207da414&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207da414",
  null
  
)

export default component.exports